import {z} from 'zod'

import {apiFetch} from '../api/fetch'
import {
    type CreateUserInput,
    createUserRequestSchema,
    type ProjectContact,
    projectContactSchema,
    type UpdateUserInput,
    updateUserRequestSchema,
    type UserAccount,
    userAccountSchema,
} from './schemas'

export async function listProjectContacts(): Promise<ProjectContact[]> {
    const raw = await apiFetch<unknown>('/users/project-contacts')
    return z.array(projectContactSchema).parse(raw)
}

export async function listUsers(): Promise<UserAccount[]> {
    const raw = await apiFetch<unknown>('/users')
    return z.array(userAccountSchema).parse(raw)
}

export async function createUser(input: CreateUserInput): Promise<UserAccount> {
    const body = createUserRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/users', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return userAccountSchema.parse(raw)
}

export async function updateUser(userId: string, input: UpdateUserInput): Promise<UserAccount> {
    const body = updateUserRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/users/${userId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
    })
    return userAccountSchema.parse(raw)
}
